import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Icon } from '@livable/saas-react-components';
import { Accordion, AccordionDetails, AccordionSummary, Checkbox, FormControlLabel, FormGroup, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import TenantsListItem from './TenantsListItem';
import useStyles from './styles';
export default function TenantsListSelector(_ref) {
  let _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$list = _ref.list,
    list = _ref$list === void 0 ? 'tenants' : _ref$list,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? undefined : _ref$type;
  const classes = useStyles();
  const _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    selectedListItems = _useState2[0],
    setSelectedListItems = _useState2[1];
  const handleListItemSelection = newListItem => {
    if (selectedListItems.includes(newListItem)) {
      setSelectedListItems(prevList => prevList.filter(listItem => listItem !== newListItem));
    } else {
      setSelectedListItems(prevList => [...prevList, newListItem]);
    }
  };
  const handleBatchSelection = e => {
    e.stopPropagation();
    const selectedListItemsCount = selectedListItems.length;
    const listItemsCount = list.length;
    if (!selectedListItemsCount) {
      setSelectedListItems(list.map(listItem => listItem));
    } else if (listItemsCount > selectedListItemsCount) {
      setSelectedListItems([]);
    } else if (listItemsCount === selectedListItemsCount) {
      setSelectedListItems([]);
    }
  };
  const listItemIsSelected = listItem => selectedListItems.includes(listItem);
  function getCheckboxIcon() {
    if (!selectedListItems.length) {
      return /*#__PURE__*/React.createElement("div", {
        className: classes.blankCheckbox
      }, /*#__PURE__*/React.createElement(Icon, {
        type: "checkbox"
      }));
    }
    if (list.length > selectedListItems.length) {
      return /*#__PURE__*/React.createElement("div", {
        className: classes.activeCheckbox
      }, /*#__PURE__*/React.createElement(Icon, {
        type: "checkbox-deselect"
      }));
    }
    if (list.length === selectedListItems.length) {
      return /*#__PURE__*/React.createElement(Icon, {
        type: "checkbox-selected"
      });
    }
    return undefined;
  }
  const checkboxesList = /*#__PURE__*/React.createElement("div", {
    className: classes.subCheckboxes
  }, list.map(listItem => /*#__PURE__*/React.createElement(TenantsListItem, {
    key: listItem,
    label: listItem,
    onChange: handleListItemSelection,
    isChecked: listItemIsSelected(listItem)
  })));
  return /*#__PURE__*/React.createElement(React.Fragment, null, type === 'building' && /*#__PURE__*/React.createElement(Accordion, {
    className: classes.listAccordion
  }, /*#__PURE__*/React.createElement(AccordionSummary, {
    "aria-controls": "checkbox-list",
    id: "checkbox-list",
    expandIcon: /*#__PURE__*/React.createElement(Icon, {
      type: "arrow-line-right",
      fontSize: "large"
    })
  }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      icon: getCheckboxIcon(),
      checked: list.length === selectedListItems.length,
      onClick: e => e.stopPropagation()
    }),
    onChange: handleBatchSelection,
    label: /*#__PURE__*/React.createElement(Typography, {
      variant: "h5",
      onClick: e => e.stopPropagation()
    }, title)
  }))), /*#__PURE__*/React.createElement(AccordionDetails, {
    className: classes.listAccordionDetails
  }, checkboxesList)), type === 'tenants' && /*#__PURE__*/React.createElement("div", {
    className: classes.checkboxList
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.plainListHeader
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.plainListArrow
  }, /*#__PURE__*/React.createElement(Icon, {
    fontSize: "large",
    type: "arrow-line-down"
  })), /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      icon: getCheckboxIcon(),
      checked: list.length === selectedListItems.length,
      onClick: e => e.stopPropagation()
    }),
    onChange: handleBatchSelection,
    label: /*#__PURE__*/React.createElement(Typography, {
      variant: "h5",
      onClick: e => e.stopPropagation()
    }, title)
  }))), checkboxesList));
}
TenantsListSelector.propTypes = {
  title: PropTypes.string,
  type: PropTypes.string,
  list: PropTypes.arrayOf(PropTypes.string)
};